import React, { Component, PropTypes } from 'react';
import { ControlledRadioButton as SparkRadioButton } from '../../../ui/sabre-spark-react-ex';
import { IN_CONTEXT_BOOKING_STATUS } from '../../../../constants/InContextBookingStatus';
import BookmarkletPreviewSection from './BookmarkletPreviewSection';
import './InContextBookingStatusControl.scss';

const STATUS_OPTIONS = [
    {
        value: IN_CONTEXT_BOOKING_STATUS.INACTIVE,
        label: 'Inactive',
        radioClass: 'in-context-radio--inactive'
    },
    {
        value: IN_CONTEXT_BOOKING_STATUS.STAGED,
        label: 'Staged',
        radioClass: 'in-context-radio--staged'
    },
    {
        value: IN_CONTEXT_BOOKING_STATUS.LIVE,
        label: 'Live',
        radioClass: 'in-context-radio--live'
    }
];

class InContextBookingStatusControl extends Component {
    handleChange = value => {
        this.props.setConfigText('inContextBookingStatus', value);
    };

    render() {
        const { currentConfigCopy, isDisabled } = this.props;
        const currentStatus = currentConfigCopy.inContextBookingStatus || IN_CONTEXT_BOOKING_STATUS.INACTIVE;
        const isStaged = currentStatus === IN_CONTEXT_BOOKING_STATUS.STAGED;

        return (
            <div className="in-context-booking-status-control">
                <h4>In-Context Booking</h4>
                <div className="in-context-status-radio-group">
                    {STATUS_OPTIONS.map(option => (
                        <SparkRadioButton
                            key={option.value}
                            className={option.radioClass}
                            name="in-context-booking-status"
                            value={option.value}
                            checked={currentStatus === option.value}
                            onChange={() => this.handleChange(option.value)}
                            disabled={isDisabled}
                        >
                            {option.label}
                        </SparkRadioButton>
                    ))}
                </div>
                {isStaged && <BookmarkletPreviewSection />}
            </div>
        );
    }
}

InContextBookingStatusControl.propTypes = {
    currentConfigCopy: PropTypes.object.isRequired,
    setConfigText: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
};

InContextBookingStatusControl.defaultProps = {
    isDisabled: false
};

export default InContextBookingStatusControl;



// WEBPACK FOOTER //
// ./src/components/pages/pages/product/InContextBookingStatusControl.js